import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/30_card_back_bamboo_bear/30_card_back_bamboo_bear"
 * Contains 1 texture(s)
 */
export class CardsBacks30CardBackBambooBearAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/30_card_back_bamboo_bear/30_card_back_bamboo_bear';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '30_bamboo_bear.png'
    ] as const;
}
